import { FC } from 'react';
import { useForm } from 'react-final-form';
import colors from 'constants/colors';
import { formatDate } from 'helpers/date';
import { limitChars, sanitizeHtml } from 'helpers/utils';

interface Props {
  pageType: string;
}

export const LeftContainer: FC<Props> = ({ pageType }) => {
  const form = useForm();
  const defaultBgColor = `linear-gradient(180deg, ${colors.oathBlue} 9.5%, ${colors.inkBlue} 106%)`;

  return (
    <div
      className="left-container"
      style={{
        background: form.getState().values?.page_background || defaultBgColor,
        color: form.getState().values?.page_color_text || colors.white,
      }}
    >
      {form.getState().values?.preview && (
        <img id="preview-file" className="preview" src={form.getState().values?.preview} />
      )}
      {pageType === 'donate' || pageType === 'recommendation' ? (
        <>
          <div className="oath-body">{form.getState().values?.page_name}</div>
          <div
            className="oath-utility"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(form.getState().values?.description) }}
          />
        </>
      ) : (
        <>
          <p className="oath-preview-text">
            {formatDate(form.getState().values?.eventDate, 'dddd, MMMM D, YYYY')}
          </p>
          <div className="oath-body">{form.getState().values?.page_name}</div>
          <p className="oath-preview-text">{form.getState().values?.subcopy}</p>
          <div className="row space-between">
            <div className="date-location-container">
              <b className="oath-preview-text">Date & Time</b>
              <div className="oath-preview-text">
                {`${formatDate(form.getState().values?.eventDate, 'MMMM D, YYYY')} ${form.getState().values?.startTime}
                                   ${form.getState().values?.endTime ? ` - ${form.getState().values?.endTime}` : ''}`}
              </div>
              <div className="oath-preview-text">
                Doors open at {form.getState().values?.startTime}
              </div>
            </div>
            {form.getState().values?.location_visibility && (
              <div className="date-location-container">
                <b className="oath-preview-text">Location</b>
                <div className="oath-preview-text">{form.getState().values?.location}</div>
              </div>
            )}
          </div>
          <br />
          <div
            className="oath-preview-text"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(limitChars(form.getState().values?.description, 1200)),
            }}
          />
        </>
      )}
    </div>
  );
};
